import { Link } from "react-router-dom";
import { ChevronRight, Handshake } from "lucide-react";

export const GRAD = "bg-gradient-to-r from-[#0A5BFF] via-[#0A8FB0] to-[#10B981]";
export const GRAD_TEXT = "bg-gradient-to-r from-[#0A7CC8] to-[#10B981] bg-clip-text text-transparent";

export function Logo() {
  return (
    <Link to="/" data-testid="le-logo" className="flex items-center gap-2.5">
      <span className={`w-10 h-10 grid place-items-center rounded-t-lg rounded-b-[18px] ${GRAD} shadow-md shadow-blue-500/20`}>
        <Handshake className="w-5 h-5 text-white" />
      </span>
      <span className="leading-none">
        <span className="block text-[19px] font-extrabold tracking-tight text-[#0B1B3F]">loanexpress</span>
        <span className="block text-[9px] font-semibold tracking-[0.18em] text-[#4B5B7C] mt-1">LOAN MARKETPLACE</span>
      </span>
    </Link>
  );
}

export function GradButton({ children, className = "", ...rest }) {
  return (
    <button
      {...rest}
      className={`${GRAD} text-white font-semibold rounded-xl inline-flex items-center justify-center gap-2 shadow-lg shadow-blue-500/20 hover:brightness-110 hover:-translate-y-px active:translate-y-0 transition-[filter,transform] disabled:opacity-60 ${className}`}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, className = "", ...rest }) {
  return (
    <button
      {...rest}
      className={`bg-white border border-slate-200 text-[#0B1B3F] font-semibold rounded-xl inline-flex items-center justify-center gap-2 hover:border-[#10B981] hover:text-[#0A8F6A] transition-colors ${className}`}
    >
      {children}
    </button>
  );
}

export function Breadcrumb({ items }) {
  return (
    <nav data-testid="le-breadcrumb" className="flex items-center gap-2 text-sm text-[#4B5B7C]">
      <Link to="/" className="hover:text-[#0B1B3F]">Home</Link>
      {items.map((it) => (
        <span key={it.label} className="flex items-center gap-2">
          <ChevronRight className="w-3.5 h-3.5" />
          {it.to ? <Link to={it.to} className="hover:text-[#0B1B3F]">{it.label}</Link> : <span className="text-[#0B1B3F]">{it.label}</span>}
        </span>
      ))}
    </nav>
  );
}

export function PageTitle({ plain, accent, sub }) {
  return (
    <div className="le-rise">
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0B1B3F] leading-[1.05]">
        {plain} <span className={GRAD_TEXT}>{accent}</span>
      </h1>
      {sub && <p className="mt-4 text-base md:text-lg text-[#4B5B7C] max-w-2xl">{sub}</p>}
    </div>
  );
}

export function LenderLogo({ p, size = "w-20 h-14" }) {
  const initials = (p.provider || "?").split(/\s+/).map((w) => w[0]).slice(0, 2).join("");
  return (
    <div className={`${size} shrink-0 rounded-xl bg-white border border-slate-100 grid place-items-center overflow-hidden p-1.5`}>
      {p.image_url
        ? <img src={p.image_url} alt={p.provider} className="max-w-full max-h-full object-contain" onError={(e) => { e.currentTarget.replaceWith(Object.assign(document.createElement("span"), { textContent: initials, className: "font-bold text-[#0A7CC8]" })); }} />
        : <span className="font-bold text-[#0A7CC8]">{initials}</span>}
    </div>
  );
}

export function IconTile({ icon: Icon, className = "" }) {
  return (
    <span className={`w-14 h-14 rounded-2xl bg-[#E8F8F1] grid place-items-center ${className}`}>
      <Icon className="w-7 h-7 text-[#10A37F]" strokeWidth={1.8} />
    </span>
  );
}
